import { render, staticRenderFns } from "./Shopmanual.vue?vue&type=template&id=5cdc15d6&"
import script from "./Shopmanual.vue?vue&type=script&lang=js&"
export * from "./Shopmanual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports